/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    errorLog: {
        optionsExclusive: {
            and: "et l'option",
            option: "L'option:",
            warning: "sont exclusives et ne peuvent pas être utilisées ensembles"
        },
        rangeInvalid: {
            incorrectValue: "La valeur de l'interval de temps donné est incorrecte"
        },
        timeInvalid: {
            incorrectValue: "La valeur du timePicker est incorrecte",
            notCorrect: "n'est pas correct"
        }
    },
    labels: {
        days: "J",
        hours: "Heures",
        minutes: "Minutes"
    }
};